<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
      :inline="true"
      :model="dataForm"
      :rules="dataRule"
      v-loading="loading"
      ref="dataForm"
    
      label-position="top"
    >
      <h1>投放产品</h1>
      <el-form-item label="公司名称" style="width: 300px">
        <el-input v-model="dataForm.companyName" disabled></el-input>
      </el-form-item>
      <el-form-item label="产品" prop="products">
        <renSelect
          v-model="dataForm.products"
          :disabled="dataForm.id"
          originPage="put"
          @input="getMoney"
          dictType="loan_type"
        ></renSelect>
      </el-form-item>
      <el-form-item label="城市" prop="city">
        <!-- <sclect-city
          v-model="dataForm.city"
          :disabled="dataForm.id"
          @input="getMoney"
        ></sclect-city> -->
        <el-select
          v-model="dataForm.city"
          :disabled="dataForm.id ? true : false"
          placeholder="请选择"
          filterable
          @input="getMoney"
        >
          <el-option
            v-for="item in cityList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="定价（元/个）" prop="productPrice">
        <el-input v-model="dataForm.productPrice" disabled></el-input>
        <p class="productPriceMsg">实际定价以结算当日价格为准</p>
      </el-form-item>
      <h1>投放时间</h1>
      <div class="ruleBox">
        <h2>规则说明：</h2>
        <p>
          投放时间设置的周期：按周循环，若当日可用余额{{
            "<"
          }}次日投放计划金额，则次日按当日余额进行投放计划消耗， <br />
          Ps:每日17点后不可提交&修改次日投放计划
        </p>
      </div>
      <br />
      <div class="pickerBox">
        <h2>投放日期：</h2>
        <el-form-item prop="startDate">
          <w-picker
            v-model="dataForm.startDate"
            placeholder="请选择开始日期"
          ></w-picker>
        </el-form-item>
        <p>~</p>
        <el-form-item prop="endDate">
          <w-picker
            v-model="dataForm.endDate"
            placeholder="请选择结束日期"
          ></w-picker>
        </el-form-item>
      </div>

      <div class="item1Box">
        <h2>投放时间段:</h2>

        <el-form-item prop="table">
          <w-table v-model="dataForm.table" ref="timelist"></w-table>
        </el-form-item>
      </div>

      <h1>
        投放数量 <span>账户余额：{{ dataForm.inactiveBalance }}元</span>
      </h1>

      <div class="ruleBox">
        <h2>规则说明：</h2>
        <p>
          以下数据为模版，结合投放日期进行线索推送。若某日有配置线索数量，但无对应投放日期，则不会收到线索。
          <br />
          例子：投放日期配置为6月9日-6月10日，对应周五、周六按照配置数量进行推送。周一至周四、周日（即使配置了数量）不推送。
        </p>
      </div>
      <br />
      <div class="itemBox">
        <h2>线索数量:</h2>
        <div>
          <el-form-item label="周一" prop="n1">
            <el-input
              type="text"
              v-model="dataForm.n1"
              placeholder=""
              @input="($event) => (dataForm.n1 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周二" prop="n2">
            <el-input
              type="number"
              v-model="dataForm.n2"
              placeholder=""
              @input="($event) => (dataForm.n2 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周三" prop="n3">
            <el-input
              type="number"
              v-model="dataForm.n3"
              placeholder=""
              @input="($event) => (dataForm.n3 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周四" prop="n4">
            <el-input
              type="number"
              v-model="dataForm.n4"
              placeholder=""
              @input="($event) => (dataForm.n4 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周五" prop="n5">
            <el-input
              type="number"
              v-model="dataForm.n5"
              placeholder=""
              @input="($event) => (dataForm.n5 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周六" prop="n6">
            <el-input
              type="number"
              v-model="dataForm.n6"
              placeholder=""
              @input="($event) => (dataForm.n6 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
          <el-form-item label="周日" prop="n7">
            <el-input
              type="number"
              v-model="dataForm.n7"
              placeholder=""
              @input="($event) => (dataForm.n7 = $event.replace(/[^0-9]/g, ''))"
            ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="footerBtn">
      <el-button style="width: 200px" @click="cancelApi">{{
        $t("cancel")
      }}</el-button>
      <el-button
        v-if="$hasPermission('put:putplan:save')"
        style="width: 200px"
        type="primary"
        @click="dataFormSubmitHandle()"
        >{{ $t("confirm") }}</el-button
      >
      <!-- <button @click="getDayOfWeek()">111</button> -->
    </div>
  </el-card>
</template>

  <script>
import city from "../../../components/my-city/city.vue";
import renSelect from "../../../components/ren-select";
import wSelect from "../../../components/my-compnay/index.vue";
import wPicker from "../../../components/w-picker";
import wTable from "../../../components/w-table";
import debounce from "lodash/debounce";

export default {
  data() {
    return {
      // mixinViewModuleOptions: {
      //   getDataListURL: "/sys/advertoauth/page",
      //   getDataListIsPage: true,
      //   exportURL: "/sys/advertoauth/export",
      //   deleteURL: "/sys/advertoauth",
      //   deleteIsBatch: true,
      // },
      loading: false,
      datelist: [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
      ],
      cityList: [],
      params: {
        accountBalance: "",
        inactiveBalance: "",
        city: "",
        companyId: "",
        companyName: "",
        createDate: "",
        creator: "",
        deleteBy: "",
        deleteTime: "",
        endDate: "",
        finalStatus: "",
        id: "",
        productPrice: "",
        products: "",
        remark: "",
        startDate: "",
        status: 0,
        tscheduleDetailDTO: [
          {
            cycle: "",
            cycleValue: "",
            detailedTime: "",
            quantity: "",
            remark: "",
            time0: "",
            time1: "",
            time10: "",
            time11: "",
            time12: "",
            time13: "",
            time14: "",
            time15: "",
            time16: "",
            time17: "",
            time18: "",
            time19: "",
            time2: "",
            time20: "",
            time21: "",
            time22: "",
            time23: "",
            time24: "",
            time25: "",
            time26: "",
            time27: "",
            time28: "",
            time29: "",
            time3: "",
            time30: "",
            time31: "",
            time32: "",
            time33: "",
            time34: "",
            time35: "",
            time36: "",
            time37: "",
            time38: "",
            time39: "",
            time4: "",
            time40: "",
            time41: "",
            time42: "",
            time43: "",
            time44: "",
            time45: "",
            time46: "",
            time47: "",
            time5: "",
            time6: "",
            time7: "",
            time8: "",
            time9: "",
            updateBy: 0,
            updateTime: "",
          },
        ],
        updateBy: "",
        updateTime: "",
      },

      dataForm: {
        id: "",
        n1: "",
        n2: "",
        n3: "",
        n4: "",
        n5: "",
        n6: "",
        n7: "",
        id: "",
        table: "",
        accountBalance: "",
        products: "",
        city: "",
        startDate: "",
        endDate: "",
        companyId: "",
        companyName: "",
        productPrice: "", // 产品定价
        tscheduleDetailDTO: [
          {
            createDate: "",
            creator: "",
            cycle: "", // 周期
            cycleValue: "", // 周期值
            dates: "",
            deleteBy: 0,
            deleteTime: "",
            detailedTime: "",
            finalStatus: 0,
            id: 0,
            quantity: 0, //线索数量
            remark: "",
            scheduleId: "",
            status: 0,
            time0: "",
            time1: "",
            time10: "",
            time11: "",
            time12: "",
            time13: "",
            time14: "",
            time15: "",
            time16: "",
            time17: "",
            time18: "",
            time19: "",
            time2: "",
            time20: "",
            time21: "",
            time22: "",
            time23: "",
            time24: "",
            time25: "",
            time26: "",
            time27: "",
            time28: "",
            time29: "",
            time3: "",
            time30: "",
            time31: "",
            time32: "",
            time33: "",
            time34: "",
            time35: "",
            time36: "",
            time37: "",
            time38: "",
            time39: "",
            time4: "",
            time40: "",
            time41: "",
            time42: "",
            time43: "",
            time44: "",
            time45: "",
            time46: "",
            time47: "",
            time5: "",
            time6: "",
            time7: "",
            time8: "",
            time9: "",
            updateBy: 0,
            updateTime: "",
          },
        ],
      },
      dataRule: {
        productPrice: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        table: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        products: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        startDate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        endDate: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
        ],
        n1: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n2: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n3: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n4: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n5: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n6: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
        n7: [
          {
            required: true,
            message: this.$t("validate.required"),
            trigger: "blur",
          },
          { validator: this.checkPositiveNumber, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getCompany();
  },
  mounted() {
    // this.dataForm.startDate = this.getDateWithOffsetDays(1);
    this.getcity();
  },
  watch: {
    $route: {
      handler(val) {
        if (!val.query.scopeCityId) {
          this.dataForm.startDate = this.getDateWithOffsetDays(
            this.is5pm() ? 2 : 1
          );
          this.cancelApi();
        }
        this.dataForm.id = "";
        this.init(val.query.scopeCityId);
      },
      immediate: true,
    },
  },
  methods: {
    checkPositiveNumber(rule, value, callback) {
      value = value + "";
      let n = value.split("").length;
      let flag = n >= 2 ? (value?.split("")[0] == 0 ? true : false) : false;
      if (value < 0 || flag) {
        callback(new Error("不能以零开头开头"));
      } else {
        callback();
      }
    },
    filterInput(e) {
      this.dataForm.n1 = this.dataForm.n1.replace(/[^0-9]/g, "");
    },

    // 获取公司
    getCompany() {
      this.$http
        .post("/sys/tschedule/deliveryInformation")
        .then(({ data: res }) => {
          if (res.code != 0) {
            this.$message.error(res.msg);
            return;
          }

          this.dataForm.companyName = res.data.companyName;
          this.dataForm.accountBalance = res.data.accountBalance
            ? res.data.accountBalance
            : 0.0;
          let money = res.data.inactiveBalance ? res.data.inactiveBalance : 0.0;
          this.$set(this.dataForm, "inactiveBalance", money);
        });
    },
    // 获取city
    getcity() {
      this.$http.post("/sys/tschedule/accessToAccess").then(({ data: res }) => {
        if (res.code != 0) {
          this.$message.error(res.msg);
          return;
        }

        this.cityList = res.data.map((item) => {
            return {
              value: item,
              label: item,
            };
          });
        console.log(res.data);
      });
    },
    // 日期大小比较
    compareDate(date1, date2) {
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      return d1 > d2;
    },
    getCount(a, b) {
      let item = this.getDayOfWeek();
      this.dataForm["n" + item] = Math.floor(a / b);
    },
    // 获取周几
    getDayOfWeek(date = "") {
      let today = "";
      if (date) {
        today = new Date(date).getDay();
      } else {
        today = new Date().getDay();
      }

      return today === 0 ? 7 : today; // 如果是星期天，返回 7，否则返回实际值
    },
    // 根据日期获取周几

    // 获取定价
    getMoney() {
      if (this.dataForm.products && this.dataForm.city) {
        let fd = new FormData();
        fd.append("city", this.dataForm.city);
        fd.append("product", this.dataForm.products);
        this.$http
          .post("/sys/tschedule/pricingAcquisition", fd)
          .then(({ data: res }) => {
            if (res.code != 0) {
              this.$message.error(res.msg);
              return;
            }
            this.dataForm.productPrice = res.data;
            if (!this.dataForm.id)
              this.getCount(
                this.dataForm.accountBalance,
                this.dataForm.productPrice
              );
          });
      }
    },
    getDateWithOffsetDays(days) {
      var now = new Date();
      now.setDate(now.getDate() + days); // 偏移指定天数

      var year = now.getFullYear();
      var month = now.getMonth() + 1; // 月份从 0 开始，需要加 1
      var date = now.getDate();

      // 返回格式为 YYYY-MM-DD 的日期字符串
      return year + "-" + this.padZero(month) + "-" + this.padZero(date);
    },

    // 辅助函数：将数字补零成两位数
    padZero(num) {
      if (num < 10) {
        return "0" + num;
      } else {
        return num.toString();
      }
    },

    // 判断时间是否选的次日超过下午五点
    isNextDayAfter5pm(dateString, hour = 17) {
      let inputDate;
      if (dateString) {
        inputDate = new Date(dateString); // 转换为日期对象
      } else {
        inputDate = new Date(); // 转换为日期对象
      }

      const tomorrow = new Date(Date.now() + 24 * 60 * 60 * 1000); // 获取明天日期

      if (
        inputDate.getDate() == tomorrow.getDate() &&
        tomorrow.getMonth == inputDate.getMonth &&
        inputDate.getFullYear == tomorrow.getFullYear
      ) {
        let now = new Date();
        var currentHour = now.getHours();

        return currentHour >= hour;
      }
      return false;
    },
    // 判断时间是否选的次日超过下午五点
    is5pm(hour = 17) {
      const now = new Date();
      const currentHour = now.getHours();
      return currentHour >= hour;
    },
    cancelApi() {
      this.$nextTick(() => {
        this.$refs?.timelist.fortable();
        this.$refs["dataForm"].resetFields();
        this.dataForm.id = "";
        this.params = {
          accountBalance: "",
          inactiveBalance: "",
          city: "",
          companyId: "",
          companyName: "",
          createDate: "",
          creator: "",
          deleteBy: "",
          deleteTime: "",
          endDate: "",
          finalStatus: "",
          id: "",
          productPrice: "",
          products: "",
          remark: "",
          startDate: "",
          status: 0,
          tscheduleDetailDTO: [
            {
              cycle: "",
              cycleValue: "",
              detailedTime: "",
              quantity: "",
              remark: "",
              time0: "",
              time1: "",
              time10: "",
              time11: "",
              time12: "",
              time13: "",
              time14: "",
              time15: "",
              time16: "",
              time17: "",
              time18: "",
              time19: "",
              time2: "",
              time20: "",
              time21: "",
              time22: "",
              time23: "",
              time24: "",
              time25: "",
              time26: "",
              time27: "",
              time28: "",
              time29: "",
              time3: "",
              time30: "",
              time31: "",
              time32: "",
              time33: "",
              time34: "",
              time35: "",
              time36: "",
              time37: "",
              time38: "",
              time39: "",
              time4: "",
              time40: "",
              time41: "",
              time42: "",
              time43: "",
              time44: "",
              time45: "",
              time46: "",
              time47: "",
              time5: "",
              time6: "",
              time7: "",
              time8: "",
              time9: "",
              updateBy: 0,
              updateTime: "",
            },
          ],
          updateBy: "",
          updateTime: "",
        };
      });
    },

    init(id) {
      this.getCompany();
      if (!id) return;
      this.dataForm.id = id;
      this.$nextTick(() => {
        this.$refs["dataForm"].resetFields();
        if (this.dataForm.id) {
          this.getInfo();
        }
      });
    },
    getParams() {
      // console.log(this.$refs.timelist.dataFrom);
      // console.log(this.$refs.timelist.tableData);
      let params = [];
      for (let i = 0; i < 7; i++) {
        // console.log(this.$refs.timelist.tableData[i]);
        let obj = JSON.parse(JSON.stringify(this.$refs.timelist.tableData[i]));

        params.push({}),
          (params[i].cycle = this.$refs.timelist.tableData[i].date);
        params[i].cycleValue = i + 1;
        params[i].detailedTime = this.$refs.timelist.dataFrom[this.datelist[i]];

        params[i].quantity = this.dataForm["n" + (i + 1)];

        for (const key in obj) {
          if (/time/.test(key)) {
            params[i][key] = JSON.stringify(obj[key]);
          }
        }
      }
      return params;
    },
    // 获取信息
    getInfo() {
      this.loading = true;
      this.$http
        .get(`/sys/tschedule/${this.dataForm.id}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }

          this.params = {
            ...this.params,
            ...res.data,
          };
          this.dataForm = {
            ...this.dataForm,
            ...res.data,
          };
          let tableList = res.data.tscheduleDetailDTO.map((item) => {
            return { ...item, date: item.cycle };
          });

          tableList.forEach((item, i) => {
            if (i == 7) {
              return;
            }
            this.dataForm["n" + (i + 1)] = item.quantity;
            for (let key in item) {
              if (/time/.test(key)) {
                tableList[i][key] = JSON.parse(tableList[i][key]);
              }
            }
          });
          let itemObj = {};

          for (let k in tableList[1]) {
            if (/time/.test(k)) {
              itemObj[k] = tableList[1][k];
            }
          }

          tableList.push(itemObj);

          this.$refs.timelist.init(tableList);
          this.getMoney();
          this.getCompany();
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    dataFormSubmitHandle: debounce(
      function () {
        if (this.isNextDayAfter5pm(this.dataForm.startDate, 17)) {
          this.$message({
            type: "error",
            message:
              "17:00后" +
              (this.dataForm.id ? "修改" : "新增") +
              "的计划，最早T+2（" +
              this.getDateWithOffsetDays(2) +
              ")日生效，请修改投放日期",
            duration: 5000,
          });

          // error(
          //   "17:00后"+(this.dataForm.id ? '修改' : '新增') +"的计划，最早T+2（" +
          //     this.getDateWithOffsetDays(2) +
          //     ")日生效，请修改投放日期"
          // );
          return;
        }

        if (this.compareDate(this.dataForm.startDate, this.dataForm.endDate)) {
          this.$message({
            type: "error",
            message: "结束日期比开始日期小请重新选择",
            duration: 5000,
          });
          return;
        }

        let res = this.getParams();

        for (let i = 0; i < 7; i++) {
          this.params.tscheduleDetailDTO[i] = {
            ...this.params.tscheduleDetailDTO[i],
            ...res[i],
          };
        }
        this.params.id = this.dataForm.id;
        this.params.city = this.dataForm.city;
        this.params.startDate = this.dataForm.startDate;
        this.params.endDate = this.dataForm.endDate;
        this.params.companyId = this.dataForm.companyId;
        this.params.productPrice = this.dataForm.productPrice;
        this.params.products = this.dataForm.products;

        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          if (this.ifmoney()) return;
          this.$http[!this.dataForm.id ? "post" : "put"](
            "/sys/tschedule",
            this.params
          )
            .then(({ data: res }) => {
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$refs["dataForm"].resetFields();
              this.$message({
                message: this.$t("prompt.success"),
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.$refs["dataForm"].resetFields();
                  this.$refs.timelist.fortable();
                  this.$router.replace("/put-tschedule?refresh=1");
                },
              });
            })
            .catch(() => {});
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    ifmoney() {
      let n = this.getDayOfWeek(this.dataForm.startDate);
      //  console.log(this.dataForm.productPrice, this.dataForm['n' + n])

      let res = Math.floor(
        this.dataForm.productPrice * (this.dataForm["n" + n] - 0)
      );

      if (res > this.dataForm.inactiveBalance) {
        this.$message({
          type: "warning",
          message: `
            您当前计划的第一投放日${this.dataForm.startDate}
            所需金额${res}元，余额（${this.dataForm.inactiveBalance}元）不足
            ，请修改线索数量或请联系商务充值，谢谢！
            `,
          duration: 5000,
        });
        // warning(`
        // 您当前计划的第一投放日${this.dataForm.startDate}
        // 所需金额${res}元，余额（${this.dataForm.inactiveBalance}元）不足
        // ，请修改线索数量或请联系商务充值，谢谢！
        // `);
        return true;
      }
      return false;
    },
  },
  components: {
    sclectCity: city,
    renSelect,
    wSelect,
    wPicker,
    wTable,
  },
};
</script>
  
<style lang="scss" scoped>
::v-deep .el-form--label-top .el-form-item__label {
  /* padding: 0; */
  line-height: 0;
}
::v-deep .el-table th {
  padding: 0;
}
.ruleBox {
  display: flex;
  align-items: center;

  > h2 {
    margin-right: 10px;
  }
  > p {
    color: #6d6969;
  }
}
h1 {
  > span {
    font-size: 16px;
    font-weight: 0;
    color: red;
  }
}
.pickerBox {
  margin: 20px 0;
  display: flex;
  align-items: center;
  > h2 {
    margin-right: 35px;
  }
  .el-form-item {
    margin: 0;
  }
  > p {
    width: 20px;
    text-align: center;
  }
}
.item1Box {
  display: flex;
  > h2 {
    margin-right: 30px;
  }
}
.itemBox {
  display: flex;
  > h2 {
    // width: 200px;
    display: flex;
    align-items: center;
    margin-right: 30px;
  }
}
.footerBtn {
  width: 80%;
  margin-top: 30px;
  display: flex;
  justify-content: center;
}
.productPriceMsg {
  padding: 0 3px;
  line-height: 20px;
  font-style: normal;
  color: #d9001b;
  text-align: center;
  background: #f5debc;

  font-size: 16px;
}
</style>